import { ITEMS_LIST_MODULE_NAME, useStore } from "./plugins/store";

export class NoResultsError extends Error {}

export const fetchStructures = async (taId, searchValue) => {
    useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/setItems', { items: [] });

    const url = window.imaiosRouting.getFosJsRoutingUrlWithSiteaccess(
        "rest_api_anatomy_treeview_search_by_taid",
        {
            'taid': encodeURIComponent(taId),
            'text': encodeURIComponent(searchValue)
        }
    );

    const response = await window.imaios.fetch(url,  {
        method: 'GET',
        headers: new Headers({ 'X-Requested-With': 'XMLHttpRequest' }) }
    );

    if (response.status >= 400 || response.redirected === true) {
        throw new Error(`Tree view search error with http code '${response.status}'`)
    }

    if (response.status === 204) {
        throw new NoResultsError();
    }

    if (response.status !== 200) {
        throw new Error(`Unexpected response http code '${response.status}' on tree view search for url '${url}'.`);
    }

    useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/setItems', { items: await response.json() });
}
